import ZTableRow from './ZTableRow.vue'

export default ZTableRow
